"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var _React$useState = react_1.default.useState(function () {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key); // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            console.log('useLocalStorage error', error);
            return initialValue;
        }
    }), storedValue = _React$useState[0], setStoredValue = _React$useState[1]; // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    var setValue = function setValue(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value; // Save state
            setStoredValue(valueToStore); // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            console.log('useLocalStorage setValue error', error);
        }
    };
    return [storedValue, setValue];
}
exports.default = useLocalStorage;
